import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { MailActionReplyParams } from 'src/app/shared/models/actions/mail-action-reply';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/shared/services/data.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ConfigDto, ContactDto, ServiceDto } from 'src/app/shared/interfaces';
import { switchMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MeService } from 'src/app/shared/services/me.service';
import { Action } from 'src/app/shared/models/action';
import { WorkflowsService } from 'src/app/shared/services/workflows.service';
import { WorkflowResponseTypeActionDTO } from 'src/app/shared/models/workflows/actions';
import { TreeSelect } from 'primeng/treeselect';
import * as _ from 'underscore';
import { TranslateService } from '@devinforius/i-essentials';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { UserInfosDetails } from 'src/app/shared/models/iCourrier/me/user-info';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ServicePTreeSelectForActions, ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { setServiceDescription } from 'src/app/utils/set-service-description.utils';

@Component({
  selector: 'app-action-response-modal',
  templateUrl: './action-response-modal.component.html',
  styleUrls: ['./action-response-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ActionResponseModalComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  public currentAction: Action;
  public actualUser: UserInfosDetails;
  public status: {
    label: string;
    value: string;
    id: number;
    ordreAffichage: number;
  }[];

  public accuseDeReponse;

  public actionResponse: UntypedFormGroup = new UntypedFormGroup({
    Response: new UntypedFormControl(null),
    // ResponseValidateAction: new UntypedFormControl(null),
    Statut: new UntypedFormControl(null),
  });

  public showStatutInput = false;

  public typeOfAnswer: null | 'Question' | 'WorkflowVariableService' | 'WorkflowVariableUser' | 'WorkflowVariableStatus' | 'WorkflowCourrierData' =
    null;

  public loaded = false;
  public questionActions: { label: string; value: boolean; id: string }[] = [
    { label: 'global.no', value: false, id: 'false' },
    { label: 'global.yes', value: true, id: 'true' },
  ];

  public flatListOfServices: ServiceDto[] = [];
  public flatListOfServicesAfterConstraint: ServiceDto[] = [];
  public listOfServices: ServicePTreeSelectForActions[] = [];
  public listOfParents = [];
  public listOfChildren = [];

  public servicesFusionned: { label: string; value: number; parentId: number }[] = [];
  public selectedOption = null; // Service selected
  public translationPlaceholderPTree: string = '';

  private workflowActionResponse: WorkflowResponseTypeActionDTO;
  private appConfig: ConfigDto;

  constructor(
    private toastr: ToastrService,
    public confirmationService: ConfirmationService,
    public dataService: DataService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private contactsService: ContactsService,
    private meService: MeService,
    public workflows: WorkflowsService,
    private translater: TranslateService,
    private actionsService: ActionsService,
    private spinner: NgxSpinnerService,
    private servicesService: ServicesService
  ) {}

  ngOnInit(): void {
    this.loaded = false;
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
    if (this.config?.data) {
      this.currentAction = this.config.data.currentAction;
      this.status = this.config.data.status;
      this.accuseDeReponse = this.config.data.accuseDeReponse;
      this.appConfig = this.config.data.appConfig;

      // Set current status of the action
      this.actionResponse.patchValue({
        Statut: this.currentAction.action.statut,
        Response: this.currentAction.action.reponse,
      });

      if (this.appConfig.mails?.hideStatutAction === false && this.status?.length) {
        this.showStatutInput = true;
      } else {
        this.showStatutInput = false;
      }
      this.getConnectedUser();
    }
  }

  /**
   * Retreive data of connected User + call method to get name
   */
  getConnectedUser(): void {
    this.meService
      .getUserInfo()
      .pipe(
        tap((res) => (this.actualUser = res)),
        switchMap(() => this.getContactById(this.actualUser.contactId))
      )
      .subscribe({
        next: (res: ContactDto) => {
          this.actualUser.name = `${res.nom ? res.nom + ' ' : ''}${res.prenom}`;
          this.getTypeOfAnswerAction();
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
          this.toastr.error('Impossible de récupérer les informations de la personne connectée!');
        },
      });
  }

  /**
   * Retrieve contact with his ID
   * @param id contactId
   * Add name to actualUser connected array
   */
  getContactById(id: number): Observable<ContactDto> {
    return this.contactsService.fetchContact(id, 'iAdmin');
  }

  private getTypeOfAnswerAction(): void {
    // Like 0 is equals to Default or null, no need to do anything. It's just the simple process.
    if (this.currentAction.action.typeReponse === 0 || this.currentAction.action.typeReponse === null) {
      this.typeOfAnswer = null;
      this.loaded = true;
      return;
    }

    this.actionResponse.addControl('commentaires', new FormControl<string>(null));
    this.actionResponse.controls.commentaires.updateValueAndValidity();

    switch (this.currentAction.action.typeReponse) {
      // type response can be any of these types : ResponseType (model : workflows/actions)
      case 1:
        this.setDatasForResponseTypeQuestion();
        break;
      case 2:
        this.setDatasForResponseTypeWorkflowVariableService();
        break;
    }
  }

  private setDatasForResponseTypeQuestion(): void {
    const actionResponseToBePatched =
      this.currentAction.action.reponse === null
        ? null
        : this.currentAction.action.reponse === this.translater.translate('global.yes')
          ? true
          : false;
    this.typeOfAnswer = 'Question';
    this.actionResponse.addControl('questionAnswer', new FormControl<boolean>(actionResponseToBePatched));
    this.actionResponse.controls.questionAnswer.setValidators([Validators.required]);
    this.actionResponse.controls.questionAnswer.updateValueAndValidity();

    this.loaded = true;
  }

  private setDatasForResponseTypeWorkflowVariableService(): void {
    this.typeOfAnswer = 'WorkflowVariableService';
    this.actionResponse.addControl('serviceChosen', new FormControl<number>(null));
    this.actionResponse.controls.serviceChosen.setValidators([Validators.required]);
    this.actionResponse.controls.serviceChosen.updateValueAndValidity();
    this.getServices();
  }

  private getServices(): void {
    this.servicesService.fetchServices().subscribe({
      next: (res) => {
        this.flatListOfServices = res.map((service) => ({
          ...service,
          description: setServiceDescription(service),
        }));
        this.getFilterServicesByContraint();
      },
    });
  }

  private getFilterServicesByContraint(): void {
    // Here we're going to check if there's another filter that needs to be applied. This filter will be based on the constraint
    this.workflows.getWorkflowActionResponse(this.currentAction.mailId, this.currentAction.action.id).subscribe({
      next: (res: WorkflowResponseTypeActionDTO) => {
        this.workflowActionResponse = res;

        // here the res.activityLastExecutionRecord.state.valueConstraint will be used to filter the services by constraint
        // res.activityLastExecutionRecord.state.valueConstraintServiceId => il s'agit du service de contrainte.
        switch (res.activityLastExecutionRecord.state.valueConstraint) {
          case null:
          case 0:
            this.setNoConstraint();
            this.loaded = true;
            break;
          case 1:
            this.loaded = true;
            break;
          case 2:
            this.loaded = true;
            break;
          case 3:
            this.loaded = true;
            break;
          case 4:
            this.loaded = true;
            break;
          case 5:
            this.setConstraintFive(res);
            break;
        }
      },
    });
  }

  // No contraint means, no condition on filtering services (except the one before of course). So we take all services, divide them into parent / children and place them recursively
  private setNoConstraint(): void {
    this.flatListOfServicesAfterConstraint = this.flatListOfServices;
    this.getParentsAndChildrenBacs(this.flatListOfServicesAfterConstraint);
  }

  // Simple divide between parents and children based on "parentId"
  private getParentsAndChildrenBacs(flatListOfServices: ServiceDto[]): void {
    const listOfParents: ServicePTreeSelectForActions[] = [];
    const listOfChildren: ServicePTreeSelectForActions[] = [];
    flatListOfServices.forEach((service) => {
      if (!service.parentId) {
        listOfParents.push(new ServicePTreeSelectForActions({ children: [], ...service }, true));
      } else {
        listOfChildren.push(new ServicePTreeSelectForActions({ children: [], ...service }, true));
      }
    });
    this.setRecursionServicesWithParentAndChildren(listOfParents, listOfChildren);
  }

  // Contraint 5 means we need to take all children of the valueConstraintServiceId.
  // Beware, the valueConstraintServiceId can be any service : root, or any children in any level
  private setConstraintFive(WorkflowResponseTypeAction: WorkflowResponseTypeActionDTO): void {
    const serviceIdForStartConstraint = WorkflowResponseTypeAction.activityLastExecutionRecord.state.valueConstraintServiceId;
    this.recursiveServicesTakeAllChildren(this.flatListOfServices, serviceIdForStartConstraint);

    //Pour la contrainte 5, on a la liste flat des enfants et on récupère le parent (qui est le bac de contrainte). Avec tout ca, on va faire notre multi level
    this.getParentAndChildrenServicesWithUniqParent(
      this.flatListOfServicesAfterConstraint,
      this.flatListOfServices.find((service) => service.id === serviceIdForStartConstraint)
    );
    this.loaded = true;
  }

  public recursiveServicesTakeAllChildren(flatListOfServices: ServiceDto[], parentId: number): void {
    // We take all children of contraint service
    flatListOfServices.forEach((service) => {
      if (service.parentId === parentId) {
        this.flatListOfServicesAfterConstraint.push(service);
        // Appel récursif pour les enfants de cet élément
        this.recursiveServicesTakeAllChildren(flatListOfServices, service.id);
      }
    });
  }

  private getParentAndChildrenServicesWithUniqParent(listOfChildren: ServiceDto[], parentServiceToBeAdded: ServiceDto): void {
    const arrayParent = [new ServicePTreeSelectForActions({ children: [], ...parentServiceToBeAdded, expanded: true }, false)];
    const arrayChildren = listOfChildren.map((childService) => {
      return new ServicePTreeSelectForActions({ children: [], ...childService }, true);
    });

    this.setRecursionServicesWithParentAndChildren(arrayParent, arrayChildren);
  }

  // Méthode générique qui va faire sa récursion basée sur la liste des parents et la liste des enfants.
  private setRecursionServicesWithParentAndChildren(
    arrayParent: ServicePTreeSelectForActions[],
    arrayChildren: ServicePTreeSelectForActions[]
  ): void {
    if (arrayChildren?.length) {
      arrayParent = arrayParent.map((parent) => {
        arrayChildren.forEach((child) => {
          if (parent.id === child.parentId) {
            parent.label = parent.description;
            parent.name = parent.description;
            parent.key = parent.id;
            parent.value = parent.id;
            parent.children.push({
              label: child.description,
              name: child.description,
              key: child.id,
              id: child.id,
              value: child.id,
              parent: parent,
              children: child.children,
            });
            this.recursion(child, arrayChildren);
          } else {
            parent.label = parent.description;
            parent.name = parent.description;
            parent.key = parent.id;
            parent.value = parent.id;
          }
        });
        return parent;
      });
    } else {
      arrayParent = arrayParent.map((parent) => {
        parent.label = parent.description;
        parent.key = parent.id;
        parent.value = parent.id;
        return parent;
      });
    }

    this.listOfServices = arrayParent;

    this.servicesFusionned = [];
    const fusionnedArray = arrayParent.concat(arrayChildren);
    fusionnedArray.forEach((item) => {
      const newItem = { ...item };
      if (newItem.parent?.label) {
        newItem.description = newItem.parent.description + ' / ' + newItem.description;
      }
      this.servicesFusionned.push({ label: newItem.description, value: newItem.id, parentId: newItem.parentId });
    });
    this.servicesFusionned = _.sortBy(this.servicesFusionned, 'label');

    // If the answer has already a bac chosen by the user, we need to patch it
    // In fact an answer can be saved but not processed
    if (JSON.parse(this.workflowActionResponse.reponseDataJson)?.value) {
      this.patchService(JSON.parse(this.workflowActionResponse.reponseDataJson)?.value);
    }
  }

  private recursion(parent: ServicePTreeSelectForActions, children: ServicePTreeSelectForActions[]): void {
    children.map((child) => {
      if (parent.id === child.parentId) {
        parent.label = (parent.codeService ? '( ' + parent.codeService + ' ) ' : '') + parent.description;
        parent.name = (parent.codeService ? '( ' + parent.codeService + ' ) ' : '') + parent.description;
        parent.key = parent.id;
        parent.value = parent.id;
        parent.children.push({
          label: (child.codeService ? '( ' + child.codeService + ' ) ' : '') + child.description,
          name: (child.codeService ? '( ' + child.codeService + ' ) ' : '') + child.description,
          key: child.id,
          value: child.id,
          id: child.id,
          parent: parent,
          children: child.children,
        });
        this.recursion(child, children);
      } else {
        parent.label = (parent.codeService ? '( ' + parent.codeService + ' ) ' : '') + parent.description;
        parent.name = (parent.codeService ? '( ' + parent.codeService + ' ) ' : '') + parent.description;
        parent.key = parent.id;
        parent.value = parent.id;
      }
    });
  }

  private patchService(serviceChosen: string): void {
    const serviceChosenNbr = +serviceChosen;
    const serviceToBePatched: ServicePTreeSelectForActions[] = [];

    this.listOfServices.forEach((service) => {
      if (service.id === serviceChosenNbr) {
        serviceToBePatched.push(service);
        return;
      } else {
        if (service.children?.length > 0) {
          recursive(serviceChosenNbr, service.children, serviceToBePatched);
        }
      }
    });
    this.treeSelect.value = serviceToBePatched;
    this.actionResponse.patchValue({
      serviceChosen: serviceToBePatched[0].id,
      Response: serviceToBePatched[0].description,
    });
    this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === serviceToBePatched[0].id));

    function recursive(serviceChosenNbr: number, children: ServicesPTreeSelect[], serviceToBePatched: ServicePTreeSelectForActions[]) {
      children.forEach((child) => {
        if (child.id === serviceChosenNbr) {
          serviceToBePatched.push(child);
          return;
        } else {
          if (child.children?.length) {
            recursive(serviceChosenNbr, child.children, serviceToBePatched);
          }
        }
      });
    }
  }

  public select(event): void {
    if (event?.node?.value) {
      if (this.selectedOption?.value !== event.node.value) {
        this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.selectedOption.label;
        this.actionResponse.patchValue({
          serviceChosen: this.selectedOption.value,
          Response: this.flatListOfServices.find((bac) => bac.id === this.selectedOption.value).description,
        });
      } else {
        this.selectedOption = null;
        const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
        labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
        this.treeSelect.value = [];
        this.actionResponse.patchValue({ serviceChosen: null, Response: null });
      }
    } else {
      this.selectedOption = null;
      const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
      labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
      this.treeSelect.value = [];
      this.actionResponse.patchValue({ serviceChosen: null, Response: null });
    }
  }

  public unselect(): void {
    this.selectedOption = null;
    const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
    labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree;
    this.treeSelect.value = [];
    this.actionResponse.patchValue({ serviceChosen: null, Response: null });
  }

  public changeSelectButtonValue(event): void {
    switch (event.value) {
      case true:
        this.actionResponse.patchValue({ Response: this.translater.translate('global.yes') });
        break;
      case false:
        this.actionResponse.patchValue({ Response: this.translater.translate('global.no') });
        break;
    }
  }

  closeModal(): void {
    this.ref.close({ replySuccess: false });
  }

  sendResponse(processAction: boolean): void {
    this.spinner.show();
    // Fill data to push the response
    let data: MailActionReplyParams = {
      statut: this.actionResponse.value.Statut,
      reponse: this.actionResponse.value.Response,
      validated: processAction, // Indicates wether the response is validated and will be marked as treated.If False, we will only update Reponse and Statut fields.
      suiviReponseMessage: this.accuseDeReponse ? 'Réponse de ' + this.actualUser.name : '', // Si le champ accuseDeReponse est à 1, alors il faut envoyer « Réponse de xxxxx » où xxxxx = nom de la personne qui a répondu
      replacementContactId: null,
      commentaires: this.actionResponse.value.commentaires,
    };

    if (this.typeOfAnswer === 'Question') {
      data.reponseData = {
        value: this.actionResponse.value.questionAnswer,
      };
    } else if (this.typeOfAnswer === 'WorkflowVariableService') {
      data.reponseData = {
        value: this.actionResponse.value.serviceChosen,
      };
    }

    this.getRemplacant(data).then((newData) => {
      data = newData;
      this.actionsService.replyToMailAction(this.currentAction.mailId, this.currentAction?.action.id, data).subscribe({
        next: () => {
          this.toastr.success('Réponse envoyée!');
          this.spinner.hide();
          this.ref.close({ replySuccess: true, isFromFlowAndProcessed: data.reponseData?.value !== undefined && processAction ? true : false });
        },
        error: (error) => {
          console.error('Error : ', error);
          this.toastr.error("Erreur lors de l'envoi de la réponse!");
          this.ref.close({ replySuccess: false });
          this.spinner.hide();
        },
      });
    });
  }

  getRemplacant(data): Promise<MailActionReplyParams> {
    return new Promise((resolve) => {
      if (this.actualUser.contactId && this.accuseDeReponse) {
        //on ne va afficher les remplaçants que si on est dans un accusé de reponse.
        this.contactsService.fetchContactsRemplacantsiCourrier([this.actualUser.contactId]).subscribe({
          next: (res) => {
            const hasAbsentPeopleArray = [];

            if (res?.length > 0) {
              res.map((remplacant) => {
                if (remplacant.absent === true && this.actualUser.contactId === remplacant.contactId) {
                  hasAbsentPeopleArray.push(remplacant);
                }
              });
            }

            if (hasAbsentPeopleArray.length > 0) {
              this.confirmationService.confirm({
                message: 'Souhaitez-vous remplacer automatiquement les personnes qui sont en congés ?',
                key: 'remplacantActionResponseModal',
                accept: () => {
                  res.map((item) => {
                    if (item.absent) {
                      if (this.actualUser.contactId === item.contactId) {
                        this.getContactById(item.remplaceParContactId).subscribe({
                          next: (res: ContactDto) => {
                            if (res) {
                              data.replacementContactId = item.remplaceParContactId;
                            }
                          },
                        });
                      }
                    }
                  });
                  resolve(data);
                },
                reject: () => {
                  resolve(data);
                },
              });
            } else resolve(data);
          },
        });
      } else resolve(data);
    });
  }

  openMail(column): void {
    const url = '/private/ic/tabs/';
    const config = environment;
    window.open(config.baseUrl + url + column.mailId);
  }
}
